import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';

export class ServiceLocator {
	static injector: Injector;
}

@NgModule({
	imports: [
		CommonModule
	]
})

export class AbstractModule {
	constructor(private injector: Injector) {
		ServiceLocator.injector = this.injector;
	}
}
